import { RadioButton, Icon, Text } from '@ui-component-library';

import type { KYCStep3Props } from './KYC.types';

export const KYCStep3 = ({ handleRadioGroup, isSelected }: KYCStep3Props) => {
  const step3Codes = ['borPaSkogsfastighet', 'borIntePaSkogsfastighet', 'agerIngenSkog'];

  const handleRadioChange = (value: string) => {
    handleRadioGroup(step3Codes, value);
  };

  return (
    <div className="w-full">
      <Text variant="text-lg/leading-normal/medium">
        Bor du på din skogsfastighet?
      </Text>
      <div
        className={`mt-8 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('borPaSkogsfastighet') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleRadioChange('borPaSkogsfastighet')}
      >
        <Icon name="HouseSimple" size="large" spacing="medium" className="bg-[#F5F5F5]" />
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">
            Ja
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <RadioButton
            name="skogsfastighet"
            value="borPaSkogsfastighet"
            checked={isSelected('borPaSkogsfastighet')}
            onClick={handleRadioChange}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('borIntePaSkogsfastighet') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleRadioChange('borIntePaSkogsfastighet')}
      >
        <Icon name="MapTrifold" size="large" spacing="medium" className="bg-[#F5F5F5]" />
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">
            Nej
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <RadioButton
            name="skogsfastighet"
            value="borIntePaSkogsfastighet"
            checked={isSelected('borIntePaSkogsfastighet')}
            onClick={handleRadioChange}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('agerIngenSkog') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleRadioChange('agerIngenSkog')}
      >
        <Icon name="PlantSimple" size="large" spacing="medium" className="bg-[#F5F5F5]" />
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">
            Jag äger ingen skog
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <RadioButton
            name="skogsfastighet"
            value="agerIngenSkog"
            checked={isSelected('agerIngenSkog')}
            onClick={handleRadioChange}
          />
        </div>
      </div>
    </div>
  );
};